import { IconButton, Button as MUIButton } from "@mui/material";
import ThemeContext from "components/app/Context";
import { useTranslate } from "hooks/useTranslate";
import React, { useContext } from "react";
import { useAppDispatch } from "redux/hooks";
import { checkUserAccess } from "utils/CommonFunctions";
import { setFeedbackDetails } from "../Snackbar/snackbar.slice";
import { buttonSizeProperty } from "./ButtonSizePropertyConfig";

interface Props {
  label?: string | JSX.Element;
  startIcon?: any;
  endIcon?: any;
  disabled?: boolean;
  variant?: "primary" | "primaryWhite" | "secondary" | "secondaryWhite" | "alert" | "contained" | "outlined" | "text";
  width?: string;
  height?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  sx?: object;
  type?: any;
  size?: "Small" | "Medium" | "Large";
  iconButton?: boolean;
  icon?: any;
  accessType?: string;
  className?: string;
}

function Button(props: Props) {
  const {
    label,
    startIcon,
    endIcon,
    onClick,
    variant = "primary",
    disabled = false,
    width,
    height,
    sx,
    type,
    size,
    iconButton = false,
    icon,
    accessType = "",
    className = ""
  } = props;

  const { isMobileScreen } = useContext(ThemeContext);
  const sizeProperty = buttonSizeProperty[size ?? isMobileScreen ? "Small" : "Medium"];
  const translate = useTranslate();
  const dispatch = useAppDispatch();
  const restrictAccess = accessType && !checkUserAccess(accessType);

  const handleClick = (event: any) => {
    if (iconButton) event.stopPropagation();
    if (restrictAccess)
      dispatch(
        setFeedbackDetails({
          shouldShow: true,
          setState: setFeedbackDetails({ shouldShow: false }),
          message: translate("user.restrictAccess")
        })
      );
    else if (onClick) onClick(event);
  };

  const disabledLook = restrictAccess
    ? {
        "&.MuiButtonBase-root:hover": {
          cursor: "default"
        },
        " &.MuiButtonBase-root": {
          opacity: "0.35"
        },
        "&:focus": {
          border: "none"
        }
      }
    : {};

  return iconButton ? (
    <IconButton disabled={disabled} sx={sx} onClick={handleClick}>
      <img src={icon} height={height} width={height} />
    </IconButton>
  ) : (
    <MUIButton
      className={className}
      sx={{
        boxSizing: "border-box",

        minWidth: width || sizeProperty?.width,
        height: height || sizeProperty?.height,
        padding: iconButton ? "0" : sizeProperty?.padding,
        gap: sizeProperty?.gap,
        fontSize: sizeProperty?.fontSize,
        lineHeight: sizeProperty?.lineHeight,
        ".icon-size": {
          width: sizeProperty?.iconWidth,
          height: sizeProperty?.iconHeight
        },
        ...sx,
        ...disabledLook
      }}
      disabled={disabled}
      onClick={handleClick}
      startIcon={startIcon}
      endIcon={endIcon}
      variant={variant}
      type={type}
    >
      {label}
    </MUIButton>
  );
}

export default Button;
